import React, { useContext, useState } from 'react';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Link } from "react-router-dom";
import { AppContext } from '../main';
import MenuLinksA from './MenuLinksA';
import {
    handlePayment
} from "../api";

const Slider = (props) => {
    const { handleEditItem } = props;
    const { appState } = useContext(AppContext);
    const { slides = {
        bgSize: 'cover', // options: 'cover', 'contain', 'auto'
        bgPosition: 'center center', // e.g. 'top center', 'center right'
        bgRepeat: 'no-repeat'  // e.g. 'repeat', 'repeat-x', 'no-repeat'
    }, editMode = false } = appState;

    if (!slides?.slides?.[0]) return null;

    // 🔧 Background image settings (easy to tweak)
    //   const [bgSize] = useState('cover'); // options: 'cover', 'contain', 'auto'
    //   const [bgPosition] = useState('center center'); // e.g. 'top center', 'center right'
    //   const [bgRepeat] = useState('no-repeat'); // e.g. 'repeat', 'repeat-x', 'no-repeat'

    return (
        <>
            {slides.menu && slides?.menuas && (
                <MenuLinksA propmenu={slides?.menuas} />
            )}

            <Swiper
                className="mainslider"
                modules={[Navigation, Pagination, Autoplay]}
                spaceBetween={50}
                slidesPerView={1}
                loop={true}
                navigation
                autoplay={{ delay: 4000 }}
                pagination={{
                    clickable: false,
                    renderBullet: function (index, className) {
                        return `<span class="${className}">${index + 1} <span class="swiper-pagination-current">/ 9</span></span>`;
                    },
                }}
            >
                {slides?.slides.map((slide) => (
                    <SwiperSlide key={slide.id}>
                        <div
                            className="swiper-inner"
                            style={{
                                backgroundImage: `url(${slide.image})`,
                                backgroundSize: slides?.bgSize,
                                backgroundPosition: slides?.bgPosition,
                                backgroundRepeat: slides?.bgRepeat,
                                width: '100%',
                                height: '100%',
                            }}
                        >
                            <div className="sw-caption">
                                <div className="container">
                                    <div className="row gx-5 align-items-center">
                                        <div className="col-lg-8 mb-sm-30">
                                            <div className="subtitle blink mb-4">{slide.header}</div>
                                            <h1 className="slider-title text-uppercase mb-1">{slide.title}</h1>
                                        </div>
                                        <div className="col-lg-6">
                                            {slide.description && <p className="slider-text">{slide.description}</p>}
                                            <div className="sw-price">
                                                <div className="d-starting">{slides.label}</div>
                                                {slide.price && <div className="d-price">
                                                    <span className="d-cur">$</span>
                                                    <span className="d-val">{slide.price}</span>
                                                </div>}
                                            </div>
                                            <div className="spacer-10"></div>
                                            {slides?.button && (
                                                <Link className="btn-main mb10" to="/"
                                                    onClick={() => {
                                                        if (slide?.priceId) {
                                                            handlePayment(slide?.priceId)
                                                        }
                                                    }}>
                                                    {slides?.button}
                                                </Link>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="sw-overlay"></div>
                        </div>
                    </SwiperSlide>
                ))}
            </Swiper>
        </>
    );
};

export default Slider;
